import '@fontsource-variable/inter';
import './index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import { AuthProvider } from '@/contexts/AuthContext';
import { ActivationProvider } from '@/contexts/ActivationContext';
import { AdelantoCartProvider } from '@/contexts/AdelantoCartContext';
import { initAnalytics } from '@/lib/analytics';

initAnalytics();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ActivationProvider>
          <AdelantoCartProvider>
            <App />
          </AdelantoCartProvider>
        </ActivationProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
